// authentication.js (Slice)
import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    jwtToken: null,
    user: null,
    role: null,
  },
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.jwtToken = action.payload.jwtToken;
      state.user = action.payload.user;
      state.role = action.payload.role;
    },
    logout: state => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.jwtToken = null;
      state.refreshToken = null;
    },
  },
});

export const { login, logout, setJWT, setUser, setRole } = authSlice.actions;

export default authSlice.reducer;
